module.exports = __webpack_public_path__ + "img/1eb6d77.jpg";